import { defineComponent as _defineComponent } from 'vue'
import { __, n__ } from '@@/bits/intl'
import OzContainedButton, { OzContainedButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'
import { toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostPollBottomSection',
  props: {
    totalVotesCount: null,
    isPollClosed: { type: Boolean },
    isShowingPollResults: { type: Boolean },
    darkMode: { type: [Boolean, String], default: 'auto' },
    isVoteButtonDisabled: { type: Boolean },
    xVoteButton: { type: Boolean },
    xResultsToggle: { type: Boolean }
  },
  emits: ["toggle-poll-results", "vote"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle-poll-results'): void
  (e: 'vote'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { totalVotesCount: number, isPollClosed: boolean, isShowingPollResults: boolean, darkMode: boolean | 'auto', isVoteButtonDisabled: boolean, xVoteButton: boolean, xResultsToggle: boolean }




const {
  darkMode,
  isPollClosed,
  totalVotesCount,
  isShowingPollResults,
  isVoteButtonDisabled,
  xVoteButton,
  xResultsToggle,
} = toRefs(props)

const togglePollResults = () => {
  emit('toggle-poll-results')
}

return { __sfc: true,emit, props, darkMode, isPollClosed, totalVotesCount, isShowingPollResults, isVoteButtonDisabled, xVoteButton, xResultsToggle, togglePollResults, __, n__, OzContainedButton, OzContainedButtonSizePreset, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset }
}

})